/* @ngInject */
const commandeButtons = (
  icons,
  commandeGo,
  commandeAsk
) => {
  const self = {}

  self.search = {
    icon: icons.search,
    action: commandeGo.consult,
    display: _nature => _nature === 'tables',
  }

  self.edit = {
    icon: icons.edit,
    action: commandeGo.edit,
    display: () => true,
  }

  self.delete = {
    icon: icons.delete,
    action: commandeAsk.delete,
    display: _nature => _nature === 'action',
    class: _commande => 'retour',
  }

  return self
}
export default commandeButtons



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/commande/resources/buttons.resource.js